/* eslint-disable unicorn/prevent-abbreviations */
import mixpanel, {
  type Config,
  type Dict,
  type OverridedMixpanel,
} from 'mixpanel-browser';

const noop = () => {};

const createActions = ({
  prod,
  e2e = false,
}: {
  prod?: boolean;
  e2e?: boolean;
}): OverridedMixpanel => {
  if (prod) {
    return {
      init: (token: string, config: Partial<Config>) =>
        mixpanel.init(token, config),
      identify: (id: string) => mixpanel.identify(id),
      track: (name: string, props: Dict) => mixpanel.track(name, props),
      people: { set_once: (props: Dict) => mixpanel.people.set_once(props) },
    } as OverridedMixpanel;
  }
  if (e2e) {
    return {
      init: (_token: string, _config: Partial<Config>) => noop,
      identify: (_id: string) => noop,
      track: (_name: string, _props: Dict) => noop,
      people: { set_once: (_props: Dict) => noop },
    } as unknown as OverridedMixpanel;
  }
  return {
    init: (token: string, config: Partial<Config>) =>
      console.info(
        `[MIXPANEL] Init: ${token} ${JSON.stringify(config, null, '\t')}`,
      ),
    identify: (id: string) => console.info(`[MIXPANEL] Identify: ${id}`),
    track: (name: string, props: Dict) =>
      console.info(`[MIXPANEL] Track: ${name}`, props),
    people: {
      set_once: (props: Dict) => console.info('[MIXPANEL] Set once:', props),
    },
  } as OverridedMixpanel;
};
export const Mixpanel = createActions;

export type Track = OverridedMixpanel['track'];
